module.exports = __webpack_public_path__ + "assets/img/prize_2.fbd781da.png";